import React, { useState, useEffect, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from "../hooks";
import {
  selectVM,
  turnOn,
  revert,
  changeVMID,
  changeVMOS,
  infectVM,
  revertVM,
  turnOnVM,
  turnOffVM,
  requestVM,
  vmStatus,
  guacamoleCreds,
  snapshots,
  takeSnapshot,
  setDesiredRevertSnapshot,
} from "../reducers/vmSlice";
import Navbar from "../assets/navbar";
import { Navigate } from "react-router-dom";

import {
  Flex,
  Input,
  Button,
  InputGroup,
  Stack,
  List,
  ListItem,
  ListIcon,
  InputLeftElement,
  chakra,
  Spacer,
  Box,
  OrderedList,
  InputRightElement,
  Alert,
  AlertIcon,
  Image,
  Text,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
} from "@chakra-ui/react";
import loginReq from "../components/loginReq";
import { selectUser } from "../reducers/userSlice";


function InfoText(){
  const aauColor = "#211a52";
  return (
    <>
    <Text fontSize='20px' as='b'>Getting started:</Text>
    <OrderedList>
      <ListItem fontSize="20px">Click Request VM to get credentials for the virtual machine.</ListItem>
      <ListItem fontSize="20px">Click connect to access the virtual machine.</ListItem>
      <ListItem fontSize="20px">Take a snapshot before infecting you virtual machine.</ListItem>
      <ListItem fontSize="20px">Run a sample to intentionally infect your virtual machine.</ListItem>
      <ListItem fontSize="20px">Have fun figuring out what it did?!</ListItem>
      <ListItem fontSize="20px">Take a snapshot after infecting your virtual machine so you can go back.</ListItem>
      <ListItem fontSize="20px">You can revert to a snapshot if you wanna start over.</ListItem>
      </OrderedList>
    </>
  )
}


function OnOffButtons(){
  const vm = useAppSelector(selectVM);
  const dispatch = useAppDispatch();

  const turnOnHandler = () => {
    let payload = {
    };
    let payloadJSON = JSON.stringify(payload);
    dispatch(turnOnVM(payloadJSON));
  }

  const turnOffHandler = () => {
    let payload = {
    };
    let payloadJSON = JSON.stringify(payload);
    dispatch(turnOffVM(payloadJSON));
  }
  let turnOnColor = "";
  let turnOffColor = "";

  if (vm.turnedOn === true) {
    turnOnColor = "gray.400";
} else {
  if (vm.aquired === true) {
  turnOnColor = "green.400";
  } else {
    turnOnColor = "gray.400";
  }

}
if (vm.turnedOn === true) {
  turnOffColor = "red.400";
} else {
  turnOffColor = "gray.400";
}

if (vm.aquired === true) {
  if (vm.turnedOn === true){
    return (
      <>
        <Button bg={turnOnColor} color="white">Turn On</Button>
        <Button onClick={turnOffHandler} bg={turnOffColor} color="white">Turn Off</Button>
      </>
    )
  }
  if (vm.turnedOn === false){
    return (
      <>
        <Button onClick={turnOnHandler} bg={turnOnColor} color="white">Turn On</Button>
        <Button bg={turnOffColor} color="white">Turn Off</Button>
      </>
    )
  }
}
  return (
    <>
      <Button bg={turnOnColor} color="white">Turn On</Button>
      <Button bg={turnOffColor} color="white">Turn Off</Button>
    </>
  )
}

function SnapshotTakeForm() {
  const aauColor = "#211a52";
  const vm = useAppSelector(selectVM);
  const dispatch = useAppDispatch();
  const [snapshotName, setSnapshotName] = useState('');
  const snapshotLoading = vm.snapshotLoading;
  const snapshotError = vm.snapshotError;
  const snapshotData = vm.snapshotData;
  const { isOpen: isSnapshotOpen, onOpen: onSnapshotOpen, onClose: onSnapshotClose } = useDisclosure()

  const handleTakeSnapshot = (e: React.FormEvent) => {
	  e.preventDefault();
	  if (snapshotName.trim() !== '') {
		  let payload = {
			  "snapshot_name": snapshotName
		  };
		  let payloadJSON = JSON.stringify(payload);
		  dispatch(takeSnapshot(payloadJSON));
	  }
  }

  let snapshotColor = "";
  if (vm.aquired === false){
    snapshotColor = "gray.400";
  } else {
    snapshotColor = aauColor;
  }

  return (
	  <>
 <Button disabled={!vm.aquired} onClick={onSnapshotOpen} bg={snapshotColor} color="white">
 Take Snapshot
 </Button>
      <Modal isOpen={isSnapshotOpen} onClose={onSnapshotClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Take a snapshot</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Enter snapshot name:
				<form onSubmit={handleTakeSnapshot}>
			<FormControl>
			<InputGroup>
			<Input mb={2}
                    type="text"
                    name="snapshot_name"
                    placeholder="Snapshot Name"
                    onChange={(e) => setSnapshotName(e.target.value)}
                    id='snapshot_name'/>
			</InputGroup>
			</FormControl>
            <Button
            type="submit"
            variant="solid"
			isLoading={snapshotLoading}
            backgroundColor={aauColor}
            color="white"
            width="full"
            >
            Take Snapshot
            </Button>
			</form>

	  {snapshotError && <p style={{ color: 'red' }}>Error: {String(snapshotError)}</p>}
      {snapshotData && <p style={{ color: 'green' }}>Snapshot created: {JSON.stringify(snapshotData)}</p>}

          </ModalBody>
        </ModalContent>
      </Modal>
	  </>
  );
}

function SnapshotList() {
  const vm = useAppSelector(selectVM);
  const dispatch = useAppDispatch();

  const handleSnapshotClick = (snapshotName: string) => {
    dispatch(setDesiredRevertSnapshot(snapshotName));
  };

  return (
    <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc' }}>
      {vm.snapshots.map((snapshot: string) => (
        <div
          key={snapshot}
          onClick={() => handleSnapshotClick(snapshot)}
          style={{
            cursor: 'pointer',
            padding: '8px',
            backgroundColor: snapshot === vm.desiredRevertSnapshot ? '#eef' : 'transparent'
          }}
        >
          {snapshot}
        </div>
      ))}
    </div>
  );
}

function RevertVmForm() {
  const aauColor = "#211a52";
  const vm = useAppSelector(selectVM);
  const dispatch = useAppDispatch();
  const { isOpen: isRevertOpen, onOpen: onRevertOpen, onClose: onRevertClose } = useDisclosure()

  const revertVmHandler = () => {
    onRevertClose(); // close revert popup
    let payload = {
	  snapshot_name:vm.desiredRevertSnapshot,
    };
    let payloadJSON = JSON.stringify(payload);
    dispatch(revertVM(payloadJSON));
  }
  const vmSnapshotsHandler = () => {
	dispatch(snapshots());
  }
  const openRevertBox  = () => {
	  vmSnapshotsHandler();
	  onRevertOpen();
  }

  let revertedColor = "";
  if (vm.aquired === false){
    revertedColor = "gray.400";
  } else {
    revertedColor = aauColor;
  }


  return (
	  <>
 <Button disabled={!vm.aquired} onClick={openRevertBox} bg={revertedColor} color="white">Revert</Button>
      <Modal isOpen={isRevertOpen} onClose={onRevertClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Revert to snapshot</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Choose snapshot you want to revert to:
			<SnapshotList />
          </ModalBody>
          <ModalFooter>
            <Button variant='ghost' mr={3} onClick={onRevertClose}>Cancel</Button>
			<Button onClick={vmSnapshotsHandler} bg={aauColor} color="white">Refresh Snapshots</Button>
            <Button onClick={revertVmHandler} bg={aauColor} color="white">Revert</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
	  </>
  );
}

function ControlButtons() {
  const aauColor = "#211a52";
  const vm = useAppSelector(selectVM);
  const dispatch = useAppDispatch();

  const requestVmHandler = () => {
    let payload = {
    };
    let payloadJSON = JSON.stringify(payload);
    dispatch(requestVM(payloadJSON));
  }
  const vmStatusHandler = useCallback(() => {
    dispatch(vmStatus());
	dispatch(guacamoleCreds());
	dispatch(snapshots());
  }, [dispatch])
  // Refresh VM status when page loads (on mount)
  useEffect(() => {
	  vmStatusHandler()
  }, [vmStatusHandler])

  let revertedColor = "";
  let aquiredColor = ""; 

  if (vm.aquired === true) {
    aquiredColor = "gray.400";
  } else {
    aquiredColor= aauColor;
  }

  return (
    <>
	<Button onClick={vmStatusHandler} bg={aauColor} color="white">Refresh VM Status</Button>
	<Button onClick={requestVmHandler} bg={aquiredColor} color="white">Request VM</Button>
	<SnapshotTakeForm />
	<RevertVmForm />

      {/* <Button onClick={() => dispatch(infectVM())} bg={isInfectedColor} color="white">Infect</Button> */}
    </>
  );
}

function DisplayVMInfo() {
  const vm = useAppSelector(selectVM);
  let turnOnColor = "";
  const aauColor = "#211a52";
  let turnOnText = "";
  let isInfectedText = "";
  let revertedColor = "";
  let revertedText = "";
  if (vm.turnedOn === true) {
    turnOnColor = "green";
    turnOnText = "Running";
  } else {
    turnOnColor = "red";
    turnOnText = "Not Running";
  }

  return (
    <>
      <Box m="10px" maxW="xl" >
      <Text fontSize='20px' as='b'> Info about virtual machine:</Text>
        <Stack direction="row" alignItems="center">
          <Text fontSize='20px'>Virtual Machine Status:</Text>
          <Badge colorScheme={turnOnColor}>{turnOnText}</Badge>
        </Stack>
        <Text fontSize='20px'>Guacamole Username: {vm.guac_username}</Text>
        <Text fontSize='20px'>Guacamole Password:  {vm.guac_password}</Text>
        <Text fontSize='20px' paddingBottom='20px'>Status:  {vm.status}</Text>
        
        <InfoText/>
      


      </Box>
    </>
  );
}

export default function SettingsPage() {
  const aauColor = "#211a52";
  const user = useAppSelector(selectUser);

  if (user.loggedIn !== true) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Navbar />

      <Flex
        flexDirection="column"
        width="100%"
        height="85vh"
        // justifyContent="center"
        alignItems="center"
        marginBottom="100px"
      >
        <Box m="20px">
          <Text
            marginBottom="10px"
            fontSize="30px"
            fontWeight="bold"
            color="#211a52"
          >
            The Box
          </Text>
        </Box>
        <Box borderWidth='2px' borderRadius='lg' borderColor={aauColor} bg="blue.50">
        <Flex flexDirection="row" gap="20px">
                  <Flex gap={3} flexDirection="column" m="10px">
                    <ControlButtons />
                  </Flex>
				  <Flex gap={3} flexDirection="column" m="10px">
					  <DisplayVMInfo />
				  </Flex>
                  
                </Flex>
        </Box>
      </Flex>
    </>
  );
}
